import { render, staticRenderFns } from "./branchOfficeList.vue?vue&type=template&id=b5297a9a&scoped=true"
import script from "./branchOfficeList.vue?vue&type=script&lang=js"
export * from "./branchOfficeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5297a9a",
  null
  
)

export default component.exports